import dayjs from 'dayjs';
import { USER_TIME_FORMAT } from 'shared/constants/date';
import type { RangePickerProps } from 'antd/es/date-picker';

export const toRangeValue = (startTime: string, endTime: string): RangePickerProps['value'] => {
  if (!startTime || !endTime) return undefined;

  const start = dayjs(startTime, USER_TIME_FORMAT, true);
  const end = dayjs(endTime, USER_TIME_FORMAT, true);

  if (!start.isValid() || !end.isValid()) return undefined;

  return [start, end];
};
